import { Stack, Skeleton, List, ListItem, Divider } from '@mui/material';

const SearchLoading = () => {
  return (
    <Stack gap={3}>
      <Skeleton
        variant='text'
        width={100}
        height={20}
      />

      <List>
        {[...Array(2)].map((_, i) => (
          <ListItem
            key={i}
            sx={{ p: 1 }}
          >
            <Stack
              direction='row'
              alignItems='center'
              gap={2}
              width='100%'
            >
              <Skeleton
                variant='circular'
                width={40}
                height={40}
              />
              <Skeleton
                variant='text'
                width='60%'
                height={24}
              />
              <Skeleton
                variant='text'
                width='30%'
                height={20}
              />
            </Stack>
          </ListItem>
        ))}
      </List>

      <Divider />

      <Stack
        direction='row'
        justifyContent='space-between'
      >
        <Skeleton
          variant='text'
          width={150}
          height={20}
        />
        <Skeleton
          variant='rounded'
          width={120}
          height={32}
        />
      </Stack>

      <List>
        {[...Array(5)].map((_, i) => (
          <ListItem
            key={i}
            sx={{ p: 1 }}
          >
            <Stack
              direction='row'
              alignItems='center'
              gap={2}
              width='100%'
            >
              <Skeleton
                variant='circular'
                width={40}
                height={40}
              />
              <Skeleton
                variant='text'
                width='60%'
                height={24}
              />
              <Skeleton
                variant='text'
                width='30%'
                height={20}
              />
            </Stack>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
};

export default SearchLoading;
